import React from 'react';
import { Route } from 'react-router-dom';
import CardGridDashboard from '../../HomePage/CardGrid.js';
import Dashboard from '../../HomePage/Dashboard.js';
import Content from '../../HomePage/Content.js';
import SpotbotLiteTutorial from '../../HomePage/Tutorial.js';
import SecurityCenter from '../../HomePage/Security.js';
import DisinfectionAnalysis from '../../Analysis/DisinfectionAnalysis.js';
import AnalysisRobotsListScreen from '../../Analysis/AnalysisRobotsListScreen.js';
import AnalysisRobotHistoryScreen from '../../Analysis/AnalysisRobotHistoryScreen.js';
import Profile from '../../HomePage/Profile.js';
import { guardRoute } from '../ProtectedRoute';

export const homeAndAnalyticsRoutes = [
  <Route key="admin-dashboard" path="/admin-dashboard" element={guardRoute(<CardGridDashboard />, '/admin-dashboard')} />,
  <Route key="dashboard" path="/control-hub" element={guardRoute(<Dashboard />, '/control-hub')} />,
  <Route key="home" path="/home" element={guardRoute(<Content />, '/home')} />,
  <Route key="profile" path="/profile" element={guardRoute(<Profile />, '/profile')} />,
  <Route
    key="tutorial-spotbot-lite"
    path="/tutorial"
    element={guardRoute(<SpotbotLiteTutorial />, '/tutorial')}
  />,
  <Route
    key="security-center"
    path="/security"
    element={guardRoute(<SecurityCenter />, '/security')}
  />,
  <Route
    key="disinfection-analysis"
    path="/disinfection-analysis"
    element={guardRoute(<DisinfectionAnalysis />, '/disinfection-analysis')}
  />,
  <Route
    key="analytics-robots-list"
    path="/analytics/robots-list"
    element={guardRoute(<AnalysisRobotsListScreen />, '/analytics/robots-list')}
  />,
  <Route
    key="analytics-robot-history"
    path="/analytics/robot/:robotId/history"
    element={guardRoute(<AnalysisRobotHistoryScreen />, '/analytics/robot/')}
  />,
];
